import React, { Fragment } from 'react';
import { I18n } from '../../i18n/I18n';
import { Moment } from '../../i18n/Moment';
import moment from 'moment';
import { Map } from 'immutable';
export var LOCKED_BY_FIELD = 'Locked By';
export var LOCKED_UNTIL_FIELD = 'Locked Until';
export var LOCK_TIME_ATTRIBUTE = 'Lock Time';
export var LOCK_CHECK_INTERVAL_ATTRIBUTE = 'Lock Check Interval';
export var LOCK_PROMPT_TIME_ATTRIBUTE = 'Lock Prompt Time';
export var LOCK_TIME_DEFAULT_VALUE = 1800; // seconds

export var LOCK_CHECK_INTERVAL_DEFAULT_VALUE = 30; // seconds

export var LOCK_PROMPT_TIME_DEFAULT_VALUE = 120; // seconds

var LoadingComponent = function LoadingComponent() {
  return /*#__PURE__*/React.createElement("div", {
    className: "text-center p-3"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "fa fa-spinner fa-spin fa-lg fa-fw"
  })));
};

var ErrorComponent = function ErrorComponent(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-center text-danger p-3"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(I18n, null, "Oops!"), " ", /*#__PURE__*/React.createElement(I18n, null, "An error occurred."))), message && /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement(I18n, null, message)));
};

var ReviewPaginationControl = function ReviewPaginationControl(_ref2) {
  var actions = _ref2.actions;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: actions.previousPage,
    disabled: !actions.previousPage
  }, "Previous Page"), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: actions.nextPage,
    disabled: !actions.nextPage
  }, "Next Page"));
};

var LockMessage = function LockMessage(_ref3) {
  var lock = _ref3.lock,
      actions = _ref3.actions;

  if (!lock) {
    return null;
  }

  return lock.isLocked ? !lock.isLockedByMe ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "fa fa-lock fw-fw mr-1"
  }), /*#__PURE__*/React.createElement(I18n, null, "This submission is locked by"), " ", lock.lockedBy, ' ', /*#__PURE__*/React.createElement(I18n, null, "until"), ' ', /*#__PURE__*/React.createElement(Moment, {
    timestamp: moment().add(lock.timeLeft, 'ms'),
    format: Moment.formats.timeWithSeconds
  }), "."), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: actions.refreshSubmission
  }, "Refresh"))) : lock.isExpiring ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "fa fa-lock fw-fw mr-1"
  }), /*#__PURE__*/React.createElement(I18n, null, "Your lock on this submission will expire at"), ' ', /*#__PURE__*/React.createElement(Moment, {
    timestamp: moment().add(lock.timeLeft, 'ms'),
    format: Moment.formats.timeWithSeconds
  }), "."), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: actions.obtainLock
  }, "Renew Lock"))) : null : /*#__PURE__*/React.createElement("div", null, !lock.lockLost ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "fa fa-unlock fw-fw mr-1"
  }), /*#__PURE__*/React.createElement(I18n, null, "This submission is currently unlocked.")), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: actions.obtainLock
  }, "Obtain Lock")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "fa fa-unlock fw-fw mr-1"
  }), /*#__PURE__*/React.createElement(I18n, null, "Your lock on this submission has expired.")), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: actions.obtainLock
  }, "Obtain Lock")));
};

export var DefaultCoreFormConfig = Map({
  Pending: LoadingComponent,
  Unauthorized: ErrorComponent,
  Forbidden: ErrorComponent,
  Unexpected: ErrorComponent,
  NotFound: ErrorComponent,
  LockMessage: LockMessage,
  ReviewPaginationControl: ReviewPaginationControl
});